// Widget CSS
import '@/css/_elementor/widgets/testimonial_slider.css';

// ..........................................................................................

import { ShuffleColors } from '@/js/utilities/color-shuffle';

import { RandomImagePositions } from '@/js/utilities/random-image-positions';

// ..........................................................................................

function initReviewsCarousel(scopeEl) {
	const slider1 = scopeEl.querySelector('.slider-testimonial_slider');

	if (slider1) {
		// const wrapper = slider1.querySelector('.swiper-wrapper');
		// const slides = Array.from(wrapper.children);
		// const slidesCount = slides.length || 1;

		new Swiper(slider1, {
			speed: 700,
			grabCursor: true,
			slideToClickedSlide: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: false,
			loop: true,
			loopAdditionalSlides: 3,
			freeMode: false,
			resistance: false,
			longSwipes: false,
			threshold: 1,

			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},

			slidesPerView: 1,
			spaceBetween: 14,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				1200: {
					slidesPerView: 'auto',
					spaceBetween: 24,
				},
				1440: {
					slidesPerView: 'auto',
					spaceBetween: 25,
				},
				1920: {
					slidesPerView: 'auto',
					spaceBetween: 27,
				},
			},
			effect: 'creative',
			creativeEffect: {
				prev: {
					translate: ['0%', 0, -400],
					rotate: [0, 0, -10],
					scale: 0.6,
					opacity: 0,
				},
				next: {
					translate: ['calc(100% + var(--page-gap))', 0, 0],
					opacity: 1,
				},
				limitProgress: 6,
			},
		});
	}
}

// ......

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/testimonial_slider.default', (scope) => {
		const scopeEl = scope[0];
		// ...

		const Slider = scopeEl.querySelector('.slider-testimonial_slider');

		if (!Slider) return;

		// Set CSS variable --slider-width to the element's current width
		function setSliderWidth() {
			const rect = Slider.getBoundingClientRect();
			const width = rect.width || Slider.offsetWidth || Slider.clientWidth || 0;
			Slider.style.setProperty('--slider-width', `${Math.round(width)}px`);
		}

		// Initial set
		setSliderWidth();

		// Update on resize using ResizeObserver where available, fall back to window resize
		if (typeof ResizeObserver !== 'undefined') {
			const ro = new ResizeObserver(() => setSliderWidth());
			ro.observe(Slider);
		} else {
			window.addEventListener('resize', setSliderWidth, { passive: true });
		}

		new ShuffleColors({
			container: Slider,
			items: '.card',
			colors: ['#B0EAC3', '#EB6942', '#F9D757', '#61A2F8', '#C9D0FC'],
		});

		// ...

		// Slider
		initReviewsCarousel(scopeEl);

		// ...

		const floatingIcons = scopeEl.querySelector('.floating-icons');

		if (!floatingIcons) return;

		function updateRandomPositions() {
			new RandomImagePositions({
				container: floatingIcons,
				items: '.floating-icon',
				padding: 48,
				cellSize: 180,
				topRightGap: window.innerWidth >= 1024 ? { width: 250, height: 150 } : { width: 0, height: 0 },
			});
		}

		setTimeout(() => {
			updateRandomPositions();
		}, 200);

		// ...
	});
});
